import { setupjQuery } from './jquery/jquery';

import { guestServices } from './guestServices/guestServices';
import { languageRedirect } from './cookies/cookie';
import { languageCookie } from './cookies/language';
import { currencyCookie } from './cookies/currency';
import { initialCurrencyAndCountry } from './cookies/initialCurrencyAndCountry';
import { snackbar } from './snackbar/snackbar';
import { header } from './header/header';
import { navigation } from './navigation/navigation';
import { footer } from './footer/footer';
import { newsletter } from './newsletter/newsletter';
import { parallax } from './header/parallax';
import { video } from './header/video';
import { swiper } from './swiper/swiper';
import { accordion } from './accordion/accordion';
import { showAll } from './showAll/showAll';
import { select } from './forms/select';
import { fieldAllowRegex } from './forms/fieldAllowRegex';
import { googleMaps } from './maps/googleMaps';
import { svgUnderline } from './svgUnderline/svgUnderline';
import { gallery } from './gallery/gallery';
import { reviews } from './reviews/reviews';
import { videoThumbnail } from './video/videoThumbnail';
import { videoLoad } from './video/videoLoad';
import { animate } from './animations/animate';
import { themeTransition } from './animations/themes';
import { blog } from './blog/blog';
import { savedSearches } from './savedSearches/savedSearches';
import { disneyRegisteredMark } from './disneyRegisteredMark/disneyRegisteredMark';

import { upcomingBookings } from './myAccount/upcomingBookings/upcomingBookings';
import { previousBookings } from './myAccount/previousBookings/previousBookings';
import { viewBooking } from './myAccount/viewBooking/viewBooking';
import { accountNav } from './myAccount/accountNav/accountNav';
import { accountHeader } from './myAccount/accountHeader/accountHeader';

import { accountCta } from './header/accountCta';

import {
  pageTracking,
  componentTracking,
  loginTracking,
  registerTracking,
  abandonBrowseTracking
} from './tracking/tracking';

import { accountOverlay } from './accountOverlay/accountOverlay';

import { concealPass } from './concealPass/concealPass';
import { showIfCaps } from './showIfCaps/showIfCaps';

import { notification } from './notification/notification';

import { loadingOverlay } from './loadingOverlay/loadingOverlay';

import { liveChat } from './livechat/livechat';

import { currencyOverlay } from './currencyOverlay/currencyOverlay';

import { featuredImageSearchComponent } from './featuredImageSearchComponent/featuredImageSearchComponent';
import { genericModal } from './modal/modal';
import { tabs } from './tabs/tabs';

import { pageLoad, footerFocus } from './autoFocus/pageLoad';

import { bookNow } from './bookNow/bookNow';

import { passEntry } from './pass-entry/pass-entry';

import { doubleImageHeaderContainer } from './doubleImageHeaderContainer/doubleImageHeaderContainer';

import { topTitleCardComponentContainer } from './topTitleCardComponentContainer/topTitleCardComponentContainer';

pageLoad();

footerFocus();

setupjQuery();

guestServices();
languageRedirect();

languageCookie();
currencyCookie();

snackbar();
header();
navigation();
footer();
newsletter();
parallax();
video();
swiper();
accordion();
showAll();
genericModal();
tabs();

// forms
select();

googleMaps();
svgUnderline();
gallery();
reviews();
videoThumbnail();
videoLoad();
animate();
themeTransition();
blog();

// MY ACCOUNT
upcomingBookings();
previousBookings();
viewBooking();
accountNav();
accountHeader();

accountCta();

//TRACKING
pageTracking();
componentTracking();
loginTracking();
registerTracking();
abandonBrowseTracking();

accountOverlay();

concealPass();
showIfCaps();

notification();

loadingOverlay();

liveChat();

fieldAllowRegex();

savedSearches();
disneyRegisteredMark();

initialCurrencyAndCountry();

currencyOverlay();

featuredImageSearchComponent();

bookNow();

passEntry();

doubleImageHeaderContainer();
topTitleCardComponentContainer();
